import { render, staticRenderFns } from "./ChargingHistoryTab.vue?vue&type=template&id=1dd06740&scoped=true"
import script from "./ChargingHistoryTab.vue?vue&type=script&lang=js"
export * from "./ChargingHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./ChargingHistoryTab.vue?vue&type=style&index=0&id=1dd06740&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd06740",
  null
  
)

export default component.exports